import { BRAND_DEFINITION } from '../../constants'

const getBrandDefinitionBreadcrumbItemByTaskId = ({
  id,
  isCurrentViewAutoResolved,
}) => ({
  path: `/tasks/brand-definition/${id}`,
  type: BRAND_DEFINITION,
  name: 'Brand Definition',
  isCurrentViewAutoResolved,
})

export default getBrandDefinitionBreadcrumbItemByTaskId
